import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import DemoCustomerDashboard from '../components/demo/DemoCustomerDashboard';
import DemoSideNav from '../components/demo/DemoSidenav';
import DemoTopBar from '../components/demo/DemoTopBar';
import DemoSignupBanner from '../components/demo/DemoSignupBanner';
import DemoEmailGate from '../components/demo/DemoEmailGate';
import { useScreenView } from '../utils/ScreenViewContext';
import { Entity } from '../types/apiTypes';

function DemoDashboard() {
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState('');
  const [subTab, setSubTab] = useState('Overview');
  const { screenView } = useScreenView();
  const [showSideNav, setShowSideNav] = useState(false);

  useEffect(() => {
    let loc = location.pathname.replace(/^\/demo\/?/, '');
    const pathSegments = loc.split('/').filter(Boolean);

    if (pathSegments.length > 0) {
      let tab = pathSegments[0];
      let sub = pathSegments[1] || '';

      const tabWithDash = tab.split('-');
      if (tabWithDash?.length > 1) {
        tab =
          tabWithDash[0][0]?.toUpperCase() +
          tabWithDash[0]?.slice(1) +
          ' ' +
          tabWithDash[1][0]?.toUpperCase() +
          tabWithDash[1]?.slice(1);
      } else {
        tab = tab[0]?.toUpperCase() + tab?.slice(1);
      }
      if (sub && sub?.length > 0) {
        const subWithDash = sub.split('-');
        if (subWithDash?.length > 1) {
          sub =
            subWithDash[0][0]?.toUpperCase() +
            subWithDash[0]?.slice(1) +
            ' ' +
            subWithDash[1][0]?.toUpperCase() +
            subWithDash[1]?.slice(1);
        } else {
          sub = sub[0]?.toUpperCase() + sub?.slice(1);
        }
      }

      setCurrentTab(tab);
      sub = sub.trim();
      if (sub === '') {
        setSubTab('Overview');
      } else {
        setSubTab(sub);
      }
    } else {
      setCurrentTab('Home');
      setSubTab('Overview');
    }
  }, [location.pathname]);

  const handleUpdateShowSideNav = (show: boolean) => {
    setShowSideNav(show);
  };

  const updateCurrentTab = (tab: string) => {
    setCurrentTab(tab);
  };

  const updateSubTab = (sub: string) => {
    setSubTab(sub);
  };

  const props = {
    currentTab,
    setCurrentTab: updateCurrentTab,
    userType: Entity.Customer,
    currentPage: location.pathname,
    subTab,
    setSubTab: updateSubTab,
    screenView,
    showSideNav,
    setShowSideNav: handleUpdateShowSideNav,
  };

  return (
    <div className="flex h-screen flex-col bg-primarybg">
      <DemoEmailGate />
      <DemoSignupBanner />
      <div
        className={`flex min-h-0 flex-1 ${
          screenView === 'tablet' || screenView === 'mobile'
            ? 'w-full flex-col overflow-hidden'
            : 'w-full flex-row justify-start overflow-hidden'
        }`}
      >
        <DemoSideNav
          currentTab={currentTab}
          setCurrentTab={updateCurrentTab}
          subTab={subTab}
          setSubTab={updateSubTab}
          showSideNav={showSideNav}
          setShowSideNav={handleUpdateShowSideNav}
          uncategorizedTransactionsCount={3}
        />
        <div
          className={`flex h-full w-full flex-1 flex-col items-center overflow-auto pb-4 ${screenView === 'desktop' && 'p-[16px]'} align-middle`}
        >
          <DemoTopBar
            currentTab={currentTab}
            setCurrentTab={updateCurrentTab}
            showSideNav={showSideNav}
            setShowSideNav={handleUpdateShowSideNav}
          />
          <DemoCustomerDashboard {...props} />
        </div>
      </div>
    </div>
  );
}

export default DemoDashboard;
